'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';

import { ROUTES } from '@/constants';

export interface UseLayoutSearchReturn {
  searchQuery: string;
  isDropdownOpen: boolean;
  onSearchChange: (value: string) => void;
  onSearchClick: (e: React.MouseEvent | React.FocusEvent) => void;
  onDropdownClose: () => void;
  onSearchSubmit: (value: string) => void;
}

/**
 * Manages search input, dropdown visibility state, and navigation for the global header search.
 */
export const useLayoutSearch = (): UseLayoutSearchReturn => {
  const router = useRouter();
  const [searchQuery, setSearchQuery] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const onSearchChange = (value: string) => {
    setSearchQuery(value);
    if (value) setIsDropdownOpen(true);
  };

  const onSearchClick = (e: React.MouseEvent | React.FocusEvent) => {
    e.stopPropagation();
    setIsDropdownOpen(true);
  };

  const onDropdownClose = () => {
    setIsDropdownOpen(false);
    setSearchQuery('');
  };

  const onSearchSubmit = (value: string) => {
    const q = value.trim();
    if (!q) return;
    const url = ROUTES.SEARCH_WITH_QUERY(encodeURIComponent(q));

    router.push(url);
  };

  return {
    searchQuery,
    isDropdownOpen,
    onSearchChange,
    onSearchClick,
    onDropdownClose,
    onSearchSubmit,
  };
};
